module.exports = __webpack_public_path__ + "img/hipercard.7cb736f3.png";